import React from "react"
import { useAuthenticatedNavigator } from "../Authenticated"

const BackButton: React.FC = () => {
    const navigator = useAuthenticatedNavigator()
    return <button type="button" name="back" className="secondary p-3" children={"Back"} onClick={navigator.back} />
}

export default BackButton
